module.exports = __webpack_public_path__ + "images/embed/toggle_closed.gif";